import { TypeInitProps } from 'types';

const data: { initProps?: TypeInitProps } = {};

export function set(key: keyof typeof data, value: any) {
  return new Promise(resolve => {
    data[key] = value;
    resolve(data);
  });
}

export function get(key: keyof typeof data) {
  return data[key];
}
